import css from 'styled-jsx/css';

export default css`
  .checkbox-container {
    display: flex;
  }
  .checkbox-container-selected {
    font-weight: 700;
  }
  .checkbox-container-selected :global(label) {
    font-weight: 700;
    color: var(--grey-dark) !important;
  }
  .select-all-alert {
    background: var(--background-utils);
    border-right: solid thin #ccc;
    display: flex;
    align-items: center;
    padding: 10px 16px;
  }
  .select-all-alert :global(.icon) {
    color: var(--grey-light);
  }
  padding .info-text {
    color: var(--grey-light);
    font-weight: 600;
    font-size: 15px;
  }
  .info-cta {
    cursor: pointer;
    color: var(--select-all);
  }
  .actions-container {
    margin: 10px 0px;
  }
  .actions-container.sticky {
    position: fixed;
    background: var(--background-sticky);
    z-index: 8;
    top: 62px;
    padding: 10px 32px;
    width: 100%;
    margin: 0px;
    box-shadow: var(--shadow-light-hover);
  }
  .actions-container.sticky.embedded-actions-container {
    top: 0 !important;
    left: 0 !important;
  }
  .l-xl {
    left: 250px;
  }
  .l-sm {
    left: 87px;
  }
  .sort {
    background: var(--sort-background);
  }
  .sort ul li {
    padding: 1em;
    cursor: pointer;
    font-weight: 400;
    border-bottom: solid thin #ddd2;
  }
  .sort li p {
    max-width: 150px !important;
    white-space: break-spaces;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
  }
  .sort ul li:hover {
    background: #ccc5;
    font-weight: 400;
  }
  .sort li {
    list-style-type: none;
    text-align: right;
    padding: var(--margin-md);
    transition: 0.2s ease;
    font-weight: 400;
  }
  .sort li:hover {
    background: #ccc5;
    cursor: pointer;
  }
  .button-group :global(.button) {
    background: none;
    border-radius: 0px;
    border: none;
    padding: 0px 16px;
  }
  .button-group.active :global(.check-button) {
    padding: 0px 16px;
    background: var(--background-utils);
    border-radius: 5px;
  }
  .button-group.active {
    border: solid thin var(--grey-lighter);
    border-radius: var(--radius);
    background: var(--background-utils);
  }
  .sort-wrapper :global(.icon) {
    font-size: 25px;
    margin: 0px !important;
    padding: 0px;
  }
  .select-language {
    height: 28px;
    width: 28px;
    cursor: pointer;
  }
  :global(.modal) {
    overflow: inherit !important;
  }
  :global(.sort-button) {
    border-right: solid thin var(--grey-lighter);
  }
  .counter {
    position: absolute;
    top: -8px;
    left: 16px;
    border-radius: 50px;
    background: var(--error);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 18px;
    height: 18px;
  }
  .counter span {
    font-size: 10px;
    color: white;
    font-weight: 600;
  }
`;
